var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { width: "100vw", "padding-right": "calc(100vw - 100%)" },
      attrs: { id: "app" },
    },
    [
      _vm.ignoreIframe()
        ? _c(
            "el-scrollbar",
            { staticStyle: { height: "100%", width: "100%" } },
            [_c("router-view")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.ignoreIframe() ? _c("router-view") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }